import { noOp } from 'common/Constants';
import React, { useCallback, useRef } from 'react';
import { ClearButton, Container, IconContainer, Input } from './styles';

interface IProps {
  icon?: React.ReactNode;
  searchQuery?: string;
  onBlur?: () => void;
  onFocus?: () => void;
  onQueryChange: (searchQuery: string, isPartialQuery: boolean) => void;
  onClearSearch: () => void;
  onSubmit?: () => void;
  clearButton?: React.ReactNode;
  placeholder?: string;
}

export const SearchInput: React.FC<IProps> = React.memo(
  ({
    icon,
    searchQuery,
    onBlur,
    onFocus,
    onQueryChange,
    onClearSearch = noOp,
    onSubmit,
    clearButton = 'clear',
    placeholder = 'shefs, cuisines, dishes',
  }) => {
    const inputRef = useRef<HTMLInputElement>(null);

    const handleKeyPress = useCallback(
      (e: React.KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' && onSubmit) {
          onSubmit();
          inputRef.current?.blur();
        }
      },
      [onSubmit]
    );

    return (
      <Container>
        {icon && <IconContainer>{icon}</IconContainer>}
        <Input
          hasIcon={!!icon}
          ref={inputRef}
          placeholder={placeholder}
          onKeyPress={handleKeyPress}
          value={searchQuery}
          onBlur={onBlur}
          onFocus={onFocus}
          onChange={(event) => {
            onQueryChange(event.currentTarget.value, true);
          }}
        />
        {searchQuery && (
          <ClearButton
            onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
              e.preventDefault();
              e.stopPropagation();
              onClearSearch();
            }}
            type='reset'
            title='Clear the search query.'>
            <u>{clearButton}</u>
          </ClearButton>
        )}
      </Container>
    );
  }
);
